interface IErrorSectionProps {
  variant?: ErrorSectionVariants;
  onClick?: () => void;
  buttonText?: string;
  shouldCenter?: boolean;
}
interface IErrorCardProps {
  title: string | JSX.Element;
  description: string | JSX.Element;
  buttonText: string | JSX.Element;
  onClick: () => void;
}
interface IErrorSectionVariants {
  title: string | JSX.Element;
  description: string | JSX.Element;
  buttonText: string | JSX.Element;
}
enum ErrorSectionVariants {
  SOMETHING_WENT_WRONG = "SOMETHING_WENT_WRONG",
}

export { ErrorSectionVariants, IErrorCardProps, IErrorSectionProps, IErrorSectionVariants };
